<template>
    <div class="row">
        <section class="col-7 row ">
            <div class="col-6 mb-4">
                <p class="mb-2">Họ và tên:</p>
                <el-input :value="detailContract?.customer?.name" placeholder="" disabled/>
            </div>
            <div class="col-6 mb-4">
                <p class="mb-2">Email:</p>
                <el-input :value="detailContract?.customer?.email" placeholder="" disabled/>
            </div>
            <div class="col-6 mb-4">
                <p class="mb-2">Số điện thoại:</p>
                <el-input :value="detailContract?.customer?.phone" placeholder="" disabled/>
            </div>
            <div class="col-6 mb-4">
                <p class="mb-2">Ngày tháng năm sinh: </p>
                <el-input :value="detailContract?.customer?.ngay_sinh" placeholder="" disabled/>
            </div>
            <div class="col-6 mb-4">
                <p class="mb-2">Trung tâm: </p>
                <el-input :value="detailContract?.center?.name" placeholder="" disabled/>
            </div>
            <div class="col-6 mb-4">
                <p class="mb-2">Chi nhánh: </p>
                <el-input :value="detailContract?.branch" placeholder="" disabled/>
            </div>
            <div class="col-6 mb-4">
                <p class="mb-2">Hình thức đóng học phí: </p>
                <el-input :value="detailContract?.tuitionCompletionForm" placeholder="" disabled/>
            </div>
        </section>
        <section class="col-5">
            <div class="card container p-4 px-0" style="background-color :#EFF2F8;">
                <div>
                    <h1 style="font-size: 16px;font-weight: bold">Khóa học đã chọn</h1>
                    <div class="d-flex justify-content-between align-items-center mb-2" style="padding: 8px; cursor: pointer"
                         @click="is_detail_course = !is_detail_course">
                        <p style="margin-bottom: 0px">Chi tiết khóa học</p>
                        <i :class="is_detail_course ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </div>
                    <div style="overflow: auto; width: 100%">
                        <table class="table " v-if="is_detail_course" style="width: max-content">
                            <tbody>
                            <tr v-for="(course_info,key) in detailContract?.student_register_courses" :key="key">
                                <td style="width: fit-content">{{ course_info.course.name }}</td>
                                <td style="width: fit-content">{{ formatMoney(course_info?.fee) }}</td>
                                <td style="width: fit-content">{{ course_info.course_sale }} %</td>
                                <td style="width: fit-content">
                                    <div class="bold">
                                        {{ formatMoney(parseInt(course_info.fee) * (1 - parseInt(course_info.course_sale) / 100)) }}
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="d-flex justify-content-between px-2">
                    <p style="word-break: keep-all" >Tổng giá khóa học (1)</p>
                    <p class="bold">{{ formatMoney(totalCourseRegisterFee) }}</p>
                </div>

                <h1 style="font-size: 16px;font-weight: bold">Chi tiết thanh toán</h1>
                <div class="d-flex justify-content-between align-items-center mb-2" style="padding: 8px; cursor: pointer"
                     @click="is_promotion_details = !is_promotion_details">
                    <p style="margin-bottom: 0px">Chi tiết khuyến mãi</p>
                    <i :class="is_promotion_details ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" ></i>
                </div>
                <div style="width: 100%">
                    <table class="table" v-if="is_promotion_details" >
                        <tbody>
                        <tr v-if="promotionForContract">
                            <td>Giảm giá mã Km:</td>
                            <td>
                                <el-tooltip class="item" effect="dark" :content="promotionForContract.name" placement="top-start">
                                    <div style="width: 190px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">{{ promotionForContract.name }}</div>
                                </el-tooltip>
                            </td>
                            <td>{{ formatMoney(promotionForContract.value) }}</td>
                        </tr>
                        <tr v-for="(voucher,index) in vouchersForContract" :key="index">
                            <td>Voucher {{ ++index }}:</td>
                            <td>
                                <el-tooltip class="item" effect="dark" :content="voucher.name" placement="top-start">
                                    <div style="width: 190px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">{{ voucher.name }}</div>
                                </el-tooltip>

                            </td>
                            <td >
                                <strong class="text-danger" v-if="voucher.unit === 1 ">{{ formatMoney(voucher.value) }}
                                    ₫</strong>
                                <strong class="text-danger" v-else>{{ voucher.value }}%</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex justify-content-between px-2">
                    <p style="word-break: keep-all">Tổng khuyến mại: (2)</p>
                    <p class="bold" style="word-break: keep-all"> {{ formatMoney(totalDiscount) }}</p>
                </div>
                <div class="d-flex justify-content-between px-2" v-if="totalDestroyFee > 0">
                    <p style="word-break: keep-all">Phí huỷ khoá: (3)</p>
                    <p class="bold" style="word-break: keep-all"> {{ formatMoney(totalDestroyFee) }}</p>
                </div>
                <hr>
                <div class="d-flex justify-content-between px-2">
                    <p style="word-break: keep-all">Tổng giá trị hợp đồng 2:
                        <el-tooltip class="item mx-2" effect="dark" :content="totalDestroyFee > 0 ? '(4) = (1) - (2) + (3)' : '(3) = (1) - (2)'" placement="top-start">
                            <i class="el-icon-info" ></i>
                        </el-tooltip>
                        <i class="cursor-pointer" @click="collapseDetail = !collapseDetail" :class="collapseDetail ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" ></i>
                    </p>
                    <p class="bold" style="word-break: keep-all">{{ formatMoney(detailContract.total_after_voucher) }}</p>
                </div>
                <div class="px-3" v-if="collapseDetail">
                    <p > Giá khoá học sau khuyến mại</p>
                    <ul class="mt-2 !list-disc space-y-2">
                        <li class="my-2" v-for="(course_info,key) in detailContract?.student_register_courses" :key="key">
                            <div class="d-flex justify-content-between">
                                <div>{{ course_info.course.name }}</div>
                                <div class="bold">{{ formatMoney(course_info.course_fee_discount) }}</div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="d-flex justify-content-between px-2">
                    <p style="word-break: keep-all">Đã thanh toán:</p>
                    <p class="bold" style="word-break: keep-all">{{ formatMoney(detailContract.total_paid) }}</p>
                </div>
                <div class="d-flex justify-content-between px-2">
                    <p style="word-break: keep-all">Còn nợ:</p>
                    <p class="bold" style="word-break: keep-all">
                        {{ formatMoney((detailContract.total_after_voucher - detailContract.total_paid)) }}</p>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "modal-detail-contract",
    props: {
        detailContract: {
            type: Object,
            default() {
                return {}
            }
        },
        flagContract: {
            type: Boolean,
            default() {
                return true;
            }
        }
    },
    mounted() {
    },
    data() {
        return {
            is_detail_course: false,
            is_promotion_details: false,
            collapseDetail: false,
        }
    },
    methods: {
        calculatorCourse(course, total, totalVoucher) {
            return course - (course / total) * totalVoucher;
        },
        formatMoney(value) {
            value = value.toLocaleString('it-IT', {style: 'currency', currency: 'VND'});
            return value
        }
    },
    computed: {
        promotionForContract() {
            return this.detailContract?.vouchers?.filter(item => item.type !== 0)?.shift();
        },
        vouchersForContract() {
            return this.detailContract.vouchers.filter(item => item.type === 0);
        },
        totalDiscount() {
            return this.detailContract.total - this.detailContract.total_after_voucher + this.totalDestroyFee;
        },
        totalValueOfVoucher() {
            return _.reduce(this.vouchersForContract, function (result, value, key) {
                if (value.unit === 1) {
                    result += value.value;
                }
                return result;
            }, 0);
        },
        totalCourseRegisterFee() {
            return this.detailContract?.student_register_courses?.reduce((result, item) => {
                return result + (item.course_fee * (100 - item.course_sale) / 100)
            }, 0);
        },
        totalDiscountByVoucher() {
            return _.reduce(this.vouchersForContract, function (result, value, key) {
                if (value.unit === 0) {
                    result += value.value;
                }
                return result;
            }, 0);
        },
        totalDestroyFee() {
            return this.detailContract?.subcontracts?.reduce((result, item) => {
                return result + (item.destroy_fee)
            }, 0);
        }
    }
}
</script>

<style scoped>
.el-collapse-head-2406 {
    height: 10px !important;
}
</style>
